var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("This page is limited access.")])])}]

export { render, staticRenderFns }